import React, {Component} from 'react';
import { ResponsiveLine } from '@nivo/line'
import {Typography} from "@material-ui/core";
import {withStyles} from "@material-ui/core/styles";
import {useTheme} from "@nivo/core";
import {inject, observer} from "mobx-react";
import {ReactComponent as ProhibitIcon} from "../../../common/images/ProhibitIcon.svg";
import {FormattedMessage} from "react-intl";


const style = theme => ({
    root:{
        position:'relative',
        display:'flex',
        width: '100%',
        height: window.innerHeight/1.8,
    },
    arrowBox:{
        position: 'relative',
        background: '#fff',
        padding: '3px 7px',
        border: '1px solid #a3a8af',
        '&:after':{
            top: '100%',
            left: '50%',
            border: 'solid transparent',
            content: "''",
            height: 0,
            width: 0,
            position: 'absolute',
            pointerEvents: 'none',
            borderColor: 'rgba(255, 255, 255, 0)',
            borderTopColor: '#ffffff',
            borderWidth: '6px',
            marginLeft: '-6px',
        },
        '&:before':{
            top: '100%',
            left: '50%',
            border: 'solid transparent',
            content: "''",
            height: 0,
            width: 0,
            position: 'absolute',
            pointerEvents: 'none',
            borderColor: 'rgba(163, 168, 175, 0)',
            borderTopColor: '#a3a8af',
            borderWidth: '7px',
            marginLeft: '-7px',
        }
    },
    imageText:{
        fontFamily:'NanumSquareRoundOTF',
        fontSize:'1.1rem',
        fontWeight:800,
        color:'#0d0d0d'
    },
    noDataBox:{
        textAlign:'center',
        position:'absolute',
        top:'50%',
        left:'50%',
        transform: 'translate( -50%, -50% )'
    },
});

@inject('statisticsStore')
@observer
class MobileConnectChart extends Component {
    render() {
        const { classes, data, statisticsStore } = this.props;

        const CustomBottomTick = tick => {
            const theme = useTheme();
            const TEXT_MAX_LENGTH = 6;
            const getShortenedText = (length, text) => text.length > length ? text.substr(0, TEXT_MAX_LENGTH) + '...' : text;
            return (
                <g transform={`translate(${tick.x},${tick.y + 22})`}>
                    <text
                        textAnchor="middle"
                        dominantBaseline="middle"
                        style={{
                            ...theme.axis.ticks.text,
                            fill: '#7b8288',
                            fontSize: '1rem',
                            fontFamily:'NanumSquareRoundOTF',
                            fontWeight:600
                        }}
                    >
                        {getShortenedText(TEXT_MAX_LENGTH, tick.value)}
                    </text>
                </g>
            )
        }

        const CustomLeftTick = tick => {
            const theme = useTheme();
            return (
                <g transform={`translate(${tick.x - 22},${tick.y})`}>
                    <text
                        textAnchor="middle"
                        dominantBaseline="middle"
                        style={{
                            ...theme.axis.ticks.text,
                            fill: '#7b8288',
                            fontSize: '1rem',
                            fontFamily:'NanumSquareRoundOTF',
                            fontWeight:600
                        }}
                    >
                        {tick.value}
                    </text>
                </g>
            )
        }

        const MyResponsiveLine = ({data}) => (
            <ResponsiveLine
                data={data}
                margin={{ top: 30, right: 40, bottom: 35, left: 50 }}
                xScale={{ type: 'point' }}
                yScale={{ type: 'linear', min: 0, max: 'auto', stacked: true, reverse: false }}
                yFormat=" >-.2f"
                axisTop={null}
                axisRight={null}
                enableGridX={false}
                lineWidth={4}
                pointSize={10}
                pointColor="#0047ac"
                pointLabel="y"
                pointLabelYOffset={-15}
                // debugSlices={true}
                crosshairType="bottom"
                useMesh={true}
                colors="#0047ac"
                legends={[]}
                theme={{
                    crosshair: {
                        line: {
                            strokeWidth: 1,
                            stroke: '#0d0d0d',
                            strokeOpacity: 1,
                            strokeDasharray: ""
                        },
                    },
                }}
                axisBottom={{
                    renderTick: CustomBottomTick,
                }}
                axisLeft={{
                    renderTick: CustomLeftTick,
                }}
                tooltip={( props ) => {
                    return (
                        <div className={classes.arrowBox}>
                            <Typography  style={{fontFamily:'NanumSquareRoundOTF',color:'#0047ac',fontSize:'1rem'}}>
                                <FormattedMessage id="access_count"/>/<span style={{fontWeight:600}}>{props.point.data.x}/{props.point.data.y}<FormattedMessage id="person"/></span>
                            </Typography>
                        </div>
                    )
                }}

            />
        )

        return (
            <div className={classes.root}>
                {data[0].data.length > 0 && MyResponsiveLine({data: data})}
                {(data[0].data.length === 0 && !statisticsStore.getIsLoading) &&
                <div style={{position: "relative", width: "100%"}}>
                    <img style={{width: "100%", height: "100%"}} src="/images/NoData_ConnectStatus.png" alt="No Data"/>
                    <div className={classes.noDataBox}>
                        <ProhibitIcon />
                        <Typography className={classes.imageText}><FormattedMessage id="msg.no_display_data"/></Typography>
                    </div>
                </div>
                }
            </div>
        );
    };
}

export default withStyles(style)(MobileConnectChart);